import { TYPES } from '../../types';

const aboutusReducer = (state, action) => {
    switch (action.type) {
        case TYPES.GET_ABOUTUS:
            return {
                ...state,
                foundation: action.payload.fundacion || null,
                philosophy: action.payload.filosofia || null,
                departments: action.payload.departamentos || null,
                commitment: action.payload.compromiso_social || null,
                anthem: action.payload.Himno || null,
                virtualTour: action.payload.virtualTour || null,
                allies: action.payload.acreditaciones || null,
                history: action.payload.historia || null,
                virtualTools: action.payload.herramientas_virtuales || null,
            }
        default:
            return state
    }
}

export default aboutusReducer;